package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.data.common.AssetReaderImpl
import com.eladfinish.bible.contest.data.common.DocumentsExporter
import com.eladfinish.bible.contest.data.common.FileStorage
import com.eladfinish.bible.contest.data.common.MyClipboardManager
import com.eladfinish.bible.contest.data.common.WebDocumentsExporter
import com.eladfinish.bible.contest.data.common.WebFileStorage
import com.eladfinish.bible.contest.data.common.WebObservableSettings
import com.eladfinish.bible.contest.data.common.stringResolver.IStringResolver
import com.eladfinish.bible.contest.data.common.stringResolver.StringResolver
import com.eladfinish.bible.contest.network.cache.CacheHelper
import com.eladfinish.bible.contest.platform.FileListFetcher
import com.russhwolf.settings.ObservableSettings
import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.binds
import org.koin.dsl.module

actual val dataPlatformModule
    get() = module {
        singleOf(::StringResolver) binds arrayOf(IStringResolver::class)
        singleOf(::MyClipboardManager)
        single<ObservableSettings> { WebObservableSettings(StorageSettings()) } binds arrayOf(Settings::class)
        single<FileStorage> { WebFileStorage() }
        single<DocumentsExporter> { WebDocumentsExporter() }
    }

actual val assetsPlatformModule
    get() = module {
        single {
            AssetReaderImpl()
        } binds arrayOf(AssetReader::class)
        single { FileListFetcher() }
    }

actual val cachePlatformModule
    get() = module {
        singleOf(::CacheHelper)
    }

actual val generalPlatformModule
    get() = module {
        // No web equivalent of "rate the app" or Play Store update prompts yet.
    }
